import React from 'react';
import PortalModal from './PortalModal';
import { BsTrash } from 'react-icons/bs';

export default function DeleteModal({
  show,
  onClose,
  onConfirm,
  message = 'Êtes-vous sûr de vouloir supprimer cet élément ?',
}) {
  return (
    <PortalModal show={show} onClose={onClose} size="sm">
      <div style={{ textAlign: 'center', paddingTop: 8 }}>
        <div style={{
          width: 64, height: 64, borderRadius: '50%',
          backgroundColor: '#ffe5e5',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px',
        }}>
          <BsTrash size={28} color="#8B0000" />
        </div>
        <p style={{ fontWeight: 600, marginBottom: 20, fontSize: 15 }}>{message}</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 24px', borderRadius: 4, border: '1px solid #ccc',
              background: '#fff', cursor: 'pointer', fontSize: 13, letterSpacing: 0.5,
            }}
          >
            ANNULER
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '8px 24px', borderRadius: 4, border: 'none',
              backgroundColor: '#8B0000', color: '#fff',
              cursor: 'pointer', fontSize: 13, letterSpacing: 0.5,
            }}
          >
            SUPPRIMER
          </button>
        </div>
      </div>
    </PortalModal>
  );
}
